// extracted by mini-css-extract-plugin
module.exports = {"user-post-challenge":"newsfeedchallengecard-module__user-post-challenge___1fmvh","more-detail":"newsfeedchallengecard-module__more-detail___1S7on"};